import { Employee, IGenericError, InstructorClassResponse } from '@libs/entity-lib';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import * as fromActions from './instructors.actions';

export interface State extends EntityState<Employee> {
  loading: boolean;
  error: IGenericError | null;
  instructorsSelected: InstructorClassResponse[];
}

export const adapter: EntityAdapter<Employee> = createEntityAdapter<Employee>({
  selectId: (employee: Employee) => employee.id ?? -1,
});

export const initialState: State = adapter.getInitialState({
  loading: false,
  error: null,
  instructorsSelected: [],
});

export const reducer = createReducer(
  initialState,
  on(fromActions.fetchInstructors, (state) => ({
    ...state,
    loading: true,
  })),
  on(fromActions.fetchInstructorsSuccessfuly, (state, { instructors }) => {
    return adapter.setAll(instructors, {
      ...state,
      loading: false,
      error: null,
    });
  }),
  on(fromActions.fetchInstructorsFailed, (state, { error }) => ({
    ...state,
    error,
    loading: false,
  })),
  on(fromActions.removeInstructorSelected, (state, { instructor }) => ({
    ...state,
    instructorsSelected: state.instructorsSelected.filter((i) => i.employee.id !== instructor.id),
  })),
  on(fromActions.fetchInstructorsByRent, (state) => ({
    ...state,
    loading: false,
  })),
  on(fromActions.fetchInstructorsByRentSuccessfuly, (state, { instructors }) => ({
    ...state,
    instructorsSelected: instructors,
  })),
  on(fromActions.fetchInstructorsByRentFailed, (state, { error }) => ({
    ...state,
    error,
    loading: false,
  }))
);

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
